import { ConfiguracaoDeTexto, ParametrosGerais, TextoModel } from "../models/textoModel"
import { CampoTextoImpressao } from "./textoImpressaoActions"

export const ParametrosGeraisInicial: ParametrosGerais = {
    negrito: false,
    qtdVias: 1,
    colunas: 48,
    qtdLinhasPosImpressao: 0,
    fonte: 0,
    textoInicioLinha: "",
    exibirLogo: false,
    linhaAposProduto: false,
}

const ConfiguracaoDeTextoInicial: ConfiguracaoDeTexto = {
    ativo: true,
    margemSuperior: 0,
    margemInferior: 0,
    margemEsquerda: 0,
    fonte: 0,
    negrito: false,
    negativo: false,
}

export const TextoImpressaoInicial: TextoModel = {
    nome: "Layout padrão",
    parametrosGerais: ParametrosGeraisInicial,
    referencia: ConfiguracaoDeTextoInicial,
    idDoPedido: ConfiguracaoDeTextoInicial,
    mesa: ConfiguracaoDeTextoInicial,
    data: ConfiguracaoDeTextoInicial,
    cliente: ConfiguracaoDeTextoInicial,
    cpf: ConfiguracaoDeTextoInicial,
    telefone: ConfiguracaoDeTextoInicial,
    previsaoEntrega: ConfiguracaoDeTextoInicial,
    rua: ConfiguracaoDeTextoInicial,
    numeroRua: ConfiguracaoDeTextoInicial,
    bairro: ConfiguracaoDeTextoInicial,
    cidade: ConfiguracaoDeTextoInicial,
    avisoCartela: ConfiguracaoDeTextoInicial,
    pedidosAnteriores: ConfiguracaoDeTextoInicial,
    avisoSimplificado: ConfiguracaoDeTextoInicial,
    consumirNoLocal: ConfiguracaoDeTextoInicial,

    categoria: ConfiguracaoDeTextoInicial,
    produto: ConfiguracaoDeTextoInicial,
    grupoDeOpcao: ConfiguracaoDeTextoInicial,
    opcao: ConfiguracaoDeTextoInicial,
    observacaoProduto: ConfiguracaoDeTextoInicial,
    observacaoPedido: ConfiguracaoDeTextoInicial,

    pagamento: ConfiguracaoDeTextoInicial,
    subtotal: ConfiguracaoDeTextoInicial,
    taxaDeEntrega: ConfiguracaoDeTextoInicial,
    desconto: ConfiguracaoDeTextoInicial,
    taxaAdicional: ConfiguracaoDeTextoInicial,
    trocoPara: ConfiguracaoDeTextoInicial,
    troco: ConfiguracaoDeTextoInicial,
    total: ConfiguracaoDeTextoInicial,
    cobrarDoCliente: ConfiguracaoDeTextoInicial,

    cnpj: ConfiguracaoDeTextoInicial,
    chavePix: ConfiguracaoDeTextoInicial,
    nomeEstabelecimento: ConfiguracaoDeTextoInicial,
    numeroEstabelecimento: ConfiguracaoDeTextoInicial,
}

const { parametrosGerais: _pg, id: _id, nome: _nome, ...camposIniciais } = TextoImpressaoInicial

export function mesclarCamposComPadrao(
    camposSalvos: Partial<Record<CampoTextoImpressao, Partial<ConfiguracaoDeTexto>>> | undefined
): Omit<TextoModel, "id" | "nome" | "parametrosGerais"> {
    const resultado = {} as Omit<TextoModel, "id" | "nome" | "parametrosGerais">
    ;(Object.keys(camposIniciais) as CampoTextoImpressao[]).forEach(campo => {
        resultado[campo] = { ...camposIniciais[campo], ...camposSalvos?.[campo] }
    })
    return resultado
}
